import download from 'downloadjs';
import { VerbFetch } from '../VerbFetch';
import { buildQueryString } from '../utils/StringUtils';

export const getReports = (params) => {
    const { type, pathsContext} = params;
    const baseUrl = `${pathsContext.adminServerUrl}/reports/${type}`;
    return VerbFetch(baseUrl);
};

//Download file
export const downloadFile = (data, fileName) => {
   const blob = new Blob([data], {type: 'application/octet-stream'});
   const url = URL.createObjectURL(blob);
   const a = document.createElement('a');
   a.href = url;
   a.download = fileName;

   a.click();

   URL.revokeObjectURL(url);
}

